// Client-related constants and configuration

export const CLIENT_TIERS = {
  BASIC: 'Basic',
  STANDARD: 'Standard',
  PREMIUM: 'Premium',
  ELITE: 'Elite',
} as const;

export const CLIENT_STATUSES = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  SUSPENDED: 'Suspended',
} as const;

export const PAYMENT_STATUSES = {
  NONE: 'None',
  INVOICE_SENT: 'Invoice Sent',
  PAID: 'Paid',
} as const;

export const SUBSCRIPTION_TYPES = {
  WEEKLY: 'Weekly',
  THREE_MONTHS: '3 Months',
  SIX_MONTHS: '6 Months',
  TWELVE_MONTHS: '12 Months',
} as const;

export const ONBOARDING_STAGES = {
  INITIAL_CONTACT: 'Initial Contact',
  ASSESSMENT_COMPLETED: 'Assessment Completed',
  PROGRAM_CREATED: 'Program Created',
  FIRST_SESSION: 'First Session',
  ACTIVE: 'Active',
} as const;

export const PRIORITY_LEVELS = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
} as const;

export const GENDER_OPTIONS = {
  MALE: 'Male',
  FEMALE: 'Female',
  OTHER: 'Other',
} as const;

// Color mappings
export const TIER_COLORS = {
  [CLIENT_TIERS.BASIC]: '#87CEEB',
  [CLIENT_TIERS.STANDARD]: '#32CD32',
  [CLIENT_TIERS.PREMIUM]: '#FFD700',
  [CLIENT_TIERS.ELITE]: '#9932CC',
} as const;

export const STATUS_COLORS = {
  [CLIENT_STATUSES.ACTIVE]: '#52c41a',
  [CLIENT_STATUSES.INACTIVE]: '#f5222d',
  [CLIENT_STATUSES.SUSPENDED]: '#faad14',
} as const;

export const PAYMENT_COLORS = {
  [PAYMENT_STATUSES.NONE]: '#d9d9d9',
  [PAYMENT_STATUSES.INVOICE_SENT]: '#faad14',
  [PAYMENT_STATUSES.PAID]: '#52c41a',
} as const;

export const PRIORITY_COLORS = {
  [PRIORITY_LEVELS.LOW]: '#52c41a',
  [PRIORITY_LEVELS.MEDIUM]: '#faad14',
  [PRIORITY_LEVELS.HIGH]: '#f5222d',
} as const;

// Table configurations
export const DEFAULT_PAGE_SIZE = 25;
export const PAGE_SIZE_OPTIONS = ['10', '25', '50', '100'];

// Date formats
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DISPLAY_DATE_FORMAT = 'MMM DD, YYYY';

// Validation rules
export const VALIDATION_RULES = {
  EMAIL_PATTERN: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE_PATTERN: /^[\+]?[1-9][\d]{0,15}$/,
  MIN_PRICE: 0,
  MAX_PRICE: 10000,
  MIN_PROGRESS: 0,
  MAX_PROGRESS: 100,
} as const; 